import { useContext, useEffect } from "react";
import { Person } from "@remo-co/ui-core/src/icons/Person";
import { OnlineRedDot } from "@remo-co/ui-core/src/icons/online";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import {
  selectCurrentEventCode,
  selectCurrentEventId,
  selectEventState,
  selectHasJoinedEvent,
  selectIsEventManager,
} from "modules/event/selectors";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { EventStates } from "modules/event";
import { selectIsMobile } from "modules/deviceInfo";
import { useI18n } from "i18n";
import { useLiveStreamingAsync } from "modules/liveStream/hooks";
import { selectLiveUserCount } from "modules/eventUserPresence/redux/selectors";
import EventCountdownTimer from "./EventCountdownTimer";
import { useStyles } from "./styles";

const UserPresence = (): JSX.Element | null => {
  const { t } = useI18n(["common"]);
  const isMobileView = useSelector(selectIsMobile);
  const styles = useStyles();
  const eventId = useSelector(selectCurrentEventId);
  const hasJoinedEvent = useSelector(selectHasJoinedEvent);
  const eventCode = useSelector(selectCurrentEventCode);
  const eventState = useSelector(selectEventState);
  const isEventManager = useSelector(selectIsEventManager);
  const onlineUserCount = useSelector(selectLiveUserCount);
  const { track } = useContext(TRACKING_CONTEXT);
  const { isLiveStreaming } = useLiveStreamingAsync();
  const { pathname } = useLocation();
  const showStreaming = isLiveStreaming && pathname === `/e/${eventCode}`;

  useEffect(() => {
    if (
      hasJoinedEvent &&
      eventId &&
      isEventManager &&
      eventState === EventStates.IN_PROGRESS
    ) {
      track(Events.UPDATE_LIVE_USERS_COUNT_IN_EVENT, {
        event: eventId, // remove after complete migration to datagol
        eventId,
        count: onlineUserCount,
      });
    }
  }, [
    hasJoinedEvent,
    eventId,
    isEventManager,
    onlineUserCount,
    eventState,
    track,
  ]);

  return (
    <div className={styles.userPresence}>
      {isEventManager && (
        <div className={styles.liveUsersCount} data-testid="live-users-count">
          <Person color="secondary" className={styles.userIcon} />
          <span>
            <Typography color="textPrimary">{onlineUserCount}</Typography>
          </span>
        </div>
      )}
      {!isMobileView && <EventCountdownTimer />}
      {showStreaming && (
        <div className={styles.streaming}>
          <OnlineRedDot />
          {t("common:streaming")}
        </div>
      )}
    </div>
  );
};

export default UserPresence;
